export default class SwInput extends ContaoWebpack.Plugin {
  init() {
    this.options = {
      ...{},
      ...this.options,
    };

    const input = this.el;

    const checkFilled = () => {
      if (this.el.value.length > 0) {
        this.el.classList.add('is-filled');
      } else {
        this.el.classList.remove('is-filled');
      }
    };

    this.el.addEventListener('blur', checkFilled);
    checkFilled();
  }
}
